import React, { Component } from 'react';
import { Form, FormGroup, Label } from 'reactstrap';

import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';

export default class LoadConfigForm extends Component {
    render() {
        return (<div className="sub-header row row-padding">
                    <div className="col-md-3 col-sm-6 text-center" style={{marginTop: "10px"}}> 
                      <span> Load Configuration From</span>
                    </div>
                    <div className="col-md-3 col-sm-6" >
                        <FormGroup>
                             <DropDown name={"group"} onChange={this.props.onLoadGroupChange} data={this.props.group_data} first_element={"--Select Group--"}/>
                             </FormGroup> 
                    </div> 
                    <div className="col-md-3 col-sm-6">
                        <FormGroup> <DropDown name={"contract"} data={this.props.contractdata} onChange={this.props.onLoadFacilityChange} first_element={"--Select Facility--"}/></FormGroup>
                    </div>
                    <div className="col-md-3 col-sm-6"> 
                        <FormGroup> <ActionButton color={"primary"} button_click={this.props.onLoadClick} size={"md"} button_name={"Load"}/></FormGroup > 
                    </div>
                </div>
        
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/load_config_form.js